export const DealerStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  BLOCKED: 'BLOCKED',
  BLOCKED_DUE_TO_PAYMENT: 'BLOCKED_DUE_TO_PAYMENT',
  REJECTED: 'REJECTED',
};
